/**
 * 资讯 新闻 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/dynamicInformation/news/page`, { params: data })
  },
}
